// src/utils/tafqeet.js
// Convert a number to Arabic words for financial documents (تفقيط)
// Supports USD (دولار) and LBP (ليرة لبنانية)

const ONES = [
  '', 'واحد', 'اثنان', 'ثلاثة', 'أربعة', 'خمسة', 'ستة', 'سبعة', 'ثمانية', 'تسعة',
  'عشرة', 'أحد عشر', 'اثنا عشر', 'ثلاثة عشر', 'أربعة عشر', 'خمسة عشر',
  'ستة عشر', 'سبعة عشر', 'ثمانية عشر', 'تسعة عشر',
];
const TENS = ['', '', 'عشرون', 'ثلاثون', 'أربعون', 'خمسون', 'ستون', 'سبعون', 'ثمانون', 'تسعون'];
const HUNDREDS = ['', 'مئة', 'مئتان', 'ثلاثمئة', 'أربعمئة', 'خمسمئة', 'ستمئة', 'سبعمئة', 'ثمانمئة', 'تسعمئة'];

function chunk(n) {
  if (n === 0) return '';
  if (n < 20) return ONES[n];
  if (n < 100) {
    const t = Math.floor(n / 10), o = n % 10;
    return o ? `${ONES[o]} و${TENS[t]}` : TENS[t];
  }
  const h = Math.floor(n / 100), rem = n % 100;
  return rem ? `${HUNDREDS[h]} و${chunk(rem)}` : HUNDREDS[h];
}

function intToWords(n) {
  if (n === 0) return 'صفر';
  const b  = Math.floor(n / 1e9);
  const m  = Math.floor((n % 1e9) / 1e6);
  const th = Math.floor((n % 1e6) / 1e3);
  const r  = n % 1e3;

  const parts = [];

  if (b) {
    if (b === 1) parts.push('مليار');
    else if (b === 2) parts.push('ملياران');
    else if (b <= 10) parts.push(`${chunk(b)} مليارات`);
    else parts.push(`${chunk(b)} مليار`);
  }
  if (m) {
    if (m === 1) parts.push('مليون');
    else if (m === 2) parts.push('مليونان');
    else if (m <= 10) parts.push(`${chunk(m)} ملايين`);
    else parts.push(`${chunk(m)} مليون`);
  }
  if (th) {
    if (th === 1) parts.push('ألف');
    else if (th === 2) parts.push('ألفان');
    else if (th <= 10) parts.push(`${chunk(th)} آلاف`);
    else parts.push(`${chunk(th)} ألف`);
  }
  if (r) parts.push(chunk(r));

  return parts.join(' و');
}

function dollarForm(n, w) {
  const last2 = n % 100;
  if (n === 1)  return 'دولار واحد';
  if (n === 2)  return 'دولاران اثنان';
  if (last2 >= 3 && last2 <= 10) return `${w} دولارات`;
  return `${w} دولاراً`;
}

function centForm(n, w) {
  const last2 = n % 100;
  if (n === 1)  return 'سنت واحد';
  if (n === 2)  return 'سنتان اثنان';
  if (last2 >= 3 && last2 <= 10) return `${w} سنتات`;
  return `${w} سنتاً`;
}

function liraForm(n, w) {
  const last2 = n % 100;
  if (n === 1)  return 'ليرة لبنانية واحدة';
  if (n === 2)  return 'ليرتان لبنانيتان';
  if (last2 >= 3 && last2 <= 10) return `${w} ليرات لبنانية`;
  return `${w} ليرة لبنانية`;
}

/**
 * tafqeetUSD(1250.75)
 * → "ألف ومئتان وخمسون دولاراً وخمسة وسبعون سنتاً فقط لا غير"
 */
export function tafqeetUSD(amount) {
  const n = Math.round(Number(amount || 0) * 100) / 100;
  if (isNaN(n) || n < 0) return '';
  const dollars = Math.floor(n);
  const cents   = Math.round((n - dollars) * 100);
  if (dollars === 0 && cents === 0) return 'صفر دولار فقط لا غير';

  const parts = [];
  if (dollars > 0) parts.push(dollarForm(dollars, intToWords(dollars)));
  if (cents   > 0) parts.push(centForm(cents,   intToWords(cents)));
  return parts.join(' و') + ' فقط لا غير';
}

/**
 * tafqeetLBP(1500000)
 * → "مليون وخمسمئة ألف ليرة لبنانية فقط لا غير"
 */
export function tafqeetLBP(amount) {
  const n = Math.round(Number(amount || 0));
  if (isNaN(n) || n < 0) return '';
  if (n === 0) return 'صفر ليرة لبنانية فقط لا غير';
  return liraForm(n, intToWords(n)) + ' فقط لا غير';
}

/**
 * Generic: tafqeet(amount, 'USD') or tafqeet(amount, 'LBP')
 */
export function tafqeet(amount, currency = 'USD') {
  return currency === 'LBP' ? tafqeetLBP(amount) : tafqeetUSD(amount);
}
